import { generateCssColorVars } from '@turbocomplynpm/theme-provider';
import * as colors from './colors';

export const generateColorVars = async () => generateCssColorVars(colors);
